import React from 'react';
import { Header } from 'components';
import './MobilePageLayout.scss';

interface MobilePageLayoutProps {
  children: React.ReactNode;
}

function MobilePageLayout({ children }: MobilePageLayoutProps) {
  return (
    <div className="mobile-layout">
      <div className="mobile-layout-header">
        <Header />
      </div>
      <div className="mobile-layout-content">{children}</div>
    </div>
  );
}

export default MobilePageLayout;
